import { Button } from "@mui/material";
import { t } from "i18next";
import mapboxgl, { Map } from "mapbox-gl";
import React, { useEffect, useRef, useState } from "react";
import { client } from "../..";
import { UpdateOrganisation } from "../../api";
import { showErrorMessage, showSuccessMessage } from "../../helper/helper";
import { Organisation } from "../../models/organisation/Organisation";
import { colorPrimaryDark } from "../../rsc/colors/colors";
import { ReactComponent as EditIcon } from "../../rsc/ic_edit.svg";
import Pickup from "../../rsc/ic_pickup.png";

type Props = {
    map: Map
    org: Organisation
    savePosition?: () => void
}

export function EditMillPosition({ map, org, savePosition }: Props) {

    const [editMode, setEditMode] = useState(false)
    const pos = useRef<any>({ lng: org.positionepsg4326.coordinates[0], lat: org.positionepsg4326.coordinates[1] })
    const markerRef = useRef<mapboxgl.Marker>(undefined)

    function addMarkerOnMap() {
        const customMarker = document.createElement('div');
        const markerImg = document.createElement('img');
        markerImg.src = Pickup;
        markerImg.style.width = "70px"
        markerImg.style.width = "35px"

        // Append the image to the custom marker
        customMarker.appendChild(markerImg);
        customMarker.style.zIndex = "8"
        const marker = new mapboxgl.Marker({
            element: customMarker,
            draggable: false,
            anchor: 'bottom'
        })
            .setLngLat([pos.current.lng, pos.current.lat])
            .addTo(map);

        markerRef.current = marker
    }

    function cancelEdit() {
        setEditMode(false)
        markerRef.current.setLngLat({ lng: org.positionepsg4326.coordinates[0], lat: org.positionepsg4326.coordinates[1] })
    }

    const onSavePostion = () => {
        savePosition?.()
        const lngLat = markerRef.current.getLngLat();
        const newCoord = [lngLat.lng, lngLat.lat]
        org.positionepsg4326 = {
            type: "Point",
            coordinates: newCoord
        }
        let newPosition = org.positionepsg4326
        client.mutate({
            mutation: UpdateOrganisation,
            variables: {
                object: {
                    positionepsg4326: newPosition
                },
                organisationId: org.id,
            }
        })
        .catch(e => showErrorMessage(e))
        .then((result) => {
            if (result) {
                showSuccessMessage(t('modification_saved'))    
            }
            setEditMode(false)
        })
    }


    useEffect(() => {
        if (markerRef.current) {
            markerRef.current.setDraggable(editMode)
            markerRef.current.getElement().style.cursor = editMode ? "pointer" : "grab"
        }
    }, [editMode])

    useEffect(() => {
        if (map && !markerRef.current) {
            addMarkerOnMap()
        }
        // eslint-disable-next-line
    }, [map])

    return (<div>
        {editMode ?
            <div style={{ position: "absolute", width: "330px", right: "35px", top: "35px", background: "#fff", padding: "15px", borderRadius: "5px" }}>
                <p style={{ color: colorPrimaryDark, fontWeight: "700", margin: "10px 0" }}>{t('edit_mill_position')}</p>
                <p style={{ color: colorPrimaryDark, fontWeight: "300", margin: "10px 0" }}>{t('edit_mill_position_instructions')}</p>
                <div style={{ textAlign: "end" }}>
                    <Button style={{ color: colorPrimaryDark, fontWeight: "500", marginRight: "10px" }} onClick={cancelEdit}>{t('cancel')}</Button>
                    <Button style={{ background: colorPrimaryDark }} variant="contained" onClick={onSavePostion}>{t('save')}</Button>
                </div>
            </div>
            : <Button onClick={() => { setEditMode(true) }}
                style={{ border: "solid black 2px", position: "absolute", background: "white" }}
                className="border-[2px] border-[black] rounded-[3px] right-[35px] top-[35px]">
                <EditIcon className="w-[20px] h-[20px] mr-[7px]" />
                <p style={{ color: "black" }}>{t('edit')}</p>
            </Button>
        }
    </div>)
}